import * as React from "react";
const SvgFiBrandsFlaticon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-flaticon_svg__a)">
      <path d="M13 8.73H7.54L5.83 5.77h8.87l2.59-4.5H2.63c-.93 0-1.82.5-2.28 1.32-.47.82-.47 1.82.01 2.64l9.35 16.21a2.647 2.647 0 0 0 3.62.93c.39-.24.72-.54.93-.93l.3-.54-4.3-7.46z" />
      <path d="M23.65 2.59a2.64 2.64 0 0 0-2.28-1.32h-.65l-7.03 12.16 2.57 4.5L23.61 5.2c.51-.79.51-1.79.03-2.61z" />
    </g>
    <defs>
      <clipPath id="fi-brands-flaticon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFlaticon;
